import TempService from "../../services";
import { hasError } from "@/utils/utils";
export default {
  actions: {
    async updateAccountInfo({ commit, dispatch }, payload) {
      commit("TempNgo/setWorking", true, { root: true });
      try {
        const res = await TempService.updateTempAccountInfo(payload);
        commit("TempNgo/setWorking", false, { root: true });

        if (hasError(res.status)) {
          throw res.statusText;
        }
        dispatch("fetchNgoData");
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
  },
};
